import axios from "axios";
var CryptoJS = require("crypto-js");

class DataApi {
    constructor() {
        this.URL = "https://" + process.env.VUE_APP_MAIN_URL + "/api/contrat-gestion";
        this.cryptageKey = "2687da56-4181-48a6-bec4-c526727423f8"
    }

    encrypt(datas) {
        return { data: CryptoJS.AES.encrypt(JSON.stringify(datas), this.cryptageKey).toString() }
    }

    decrypt(data) {
        var bytes = CryptoJS.AES.decrypt(data, this.cryptageKey);
        var originalData = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return originalData
    }

    get_material_liste(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/material/list', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_contrat_informations(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_contrat_informations', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_sub_family_list(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_sub_family_list', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_family_list(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_family_list', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_clients(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_clients', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_contrats(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_contrats', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_parc(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_parc', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_stock(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_stock', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_or_liste(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_or_liste', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_techniciens(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_techniciens', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_retrait_list(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_retrait_list', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_agences(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_agences', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    creat_new_or(oRdata, callback) {
        let datas = { oRdata }
        axios.post(this.URL + '/v1/creat_new_or', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    creat_new_moteur_line(motorData, callback) {
        let datas = { motorData }
        axios.post(this.URL + '/v1/creat_new_moteur_line', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    creat_contrat(contratData, callback) {
        let datas = { contratData }
        axios.post(this.URL + '/v1/creat_contrat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    add_mat(contratData, callback) {
        let datas = { contratData }
        axios.post(this.URL + '/v1/add_mat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_orListe_byLink(link, callback) {
        let datas = { link }
        axios.post(this.URL + '/v1/get_orListe_byLink', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    delete_or_by_id(id, callback) {
        let datas = { id }
        axios.post(this.URL + '/v1/delete_or_by_id', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    delete_or2_by_id(id, callback) {
        let datas = { id }
        axios.post(this.URL + '/v1/delete_or2_by_id', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_options(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_options', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    is_materiel_free(uuid, callback) {
        let datas = { uuid }
        axios.post(this.URL + '/v1/is_materiel_free', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    destock_materiel(uuid, callback) {
        let datas = { uuid }
        axios.post(this.URL + '/v1/destock_materiel', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_city_liste(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_city_liste', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_city_liste_from_zipcode(code, callback) {
        let datas = { code }
        axios.post(this.URL + '/v1/get_city_liste_from_zipcode', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }
    client_create(data, callback) {
        let datas = { data }
        axios.post(this.URL + '/v1/client_create', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    send_to_facturation(idLigne, numContrat, paiement, callback) {
        let datas = { idLigne, numContrat, paiement }
        axios.post(this.URL + '/v1/send_to_facturation', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    update_caution(idLigne, modeDepot, montant, callback) {
        let datas = { idLigne, modeDepot, montant }
        axios.post(this.URL + '/v1/update_caution', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_contrat_matricul_liste(contrat, callback) {
        let datas = { contrat }
        axios.post(this.URL + '/v1/get_contrat_matricul_liste', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    renew_contrat(contrat, callback) {
        let datas = { contrat }
        axios.post(this.URL + '/v1/renew_contrat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    change_matricule(contrat, idcldata, matricule, nvMatricule, callback) {
        let datas = { contrat, idcldata, matricule, nvMatricule }
        axios.post(this.URL + '/v1/change_matricule', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    update_contrat(contrat, callback) {
        let datas = { contrat }
        axios.post(this.URL + '/v1/update_contrat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_clients_by_name(name, callback) {
        let datas = { name }
        axios.post(this.URL + '/v1/get_clients_by_name', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    facturation(contrat, user, callback) {
        let datas = { contrat, user }
        axios.post(this.URL + '/v1/facturation', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    send_mat_etadl(id, callback) {
        let datas = { id }
        axios.post(this.URL + '/v1/send_mat_etadl', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    send_mat_or(matricul, contrat, id, commente, callback) {
        let datas = { matricul, contrat, id, commente }
        axios.post(this.URL + '/v1/send_mat_or', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    delete_mat(contrat, callback) {
        let datas = { contrat }
        axios.post(this.URL + '/v1/delete_mat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    sortie_mat(idContrat, callback) {
        let datas = { idContrat }
        axios.post(this.URL + '/v1/sortie_mat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    retour_mat(idContrat, callback) {
        let datas = { idContrat }
        axios.post(this.URL + '/v1/retour_mat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    cancel_mat(idContrat, callback) {
        let datas = { idContrat }
        axios.post(this.URL + '/v1/cancel_mat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    cloture_contrat(contrat, callback) {
        let datas = { contrat }
        axios.post(this.URL + '/v1/cloture_contrat', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    send_to_signe(id, callback) {
        let datas = { id }
        axios.post(this.URL + '/v1/send_to_signe', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_agency_list(callback) {
        let datas = {}
        axios.post(this.URL + '/v1/get_agency_list', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    edit_client(client, callback) {
        let datas = { client }
        axios.post(this.URL + '/v1/edit_client', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_sub_family_info(subFamily, callback) {
        let datas = { subFamily }
        axios.post(this.URL + '/v1/get_sub_family_info', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    get_contrat_pj(gm, callback) {
        let datas = { gm }
        axios.post(this.URL + '/v1/get_contrat_pj', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    update_contrat_from_SSynch(CLD_ID_WEB, CLD_MATRICULE, callback) {
        let datas = { CLD_ID_WEB, CLD_MATRICULE }
        axios.post(this.URL + '/v1/update_contrat_from_SSynch', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    update_info_file_uploaded(contratNum, callback) {
        let datas = { contratNum }
        axios.post(this.URL + '/v1/update_info_file_uploaded', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    getSignedFileData(contratNum, codeClient, callback) {
        console.log("inside getSignedFileData");
        let datas = { contratNum, codeClient }
        axios.post(this.URL + '/v1/getSignedFileData', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }


    File_Upload(code, extraPath, name, file, callback) {
        var datas = { file, extraPath, code, name }

        axios.post(this.URL + '/v1/file/upload', datas, {
            responseType: 'json',
            credentials: false,
            'Content-Type': `multipart/form-data`,
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    File_Exist(filename, code, callback) {
        var datas = { filename, code };
        axios.post(this.URL + '/v1/file/exist', this.encrypt(datas), {
            responseType: 'json',
            credentials: false
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }

    File_download_from_path(code, name, callback) {
        console.log("File_download_from_path");

        let datas = { code, name }
        axios.post(this.URL + '/v1/file/download', this.encrypt(datas), {
            responseType: 'json',
            credentials: false,
            headers: {}
        }).then(res => {
            callback(this.decrypt(res.data));
        });
    }
}

export default new DataApi()